var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BaseModal',{ref:"BaseModal",on:{"confirm":_vm.confirm}},[_c('div',{staticClass:"history-project-dialog"},[_c('SearchSetting',{ref:"searchSetting",staticClass:"tab-btn"}),_vm._v(" "),_c('MatchProject',{ref:"matchProjectRef",staticClass:"tab-btn",attrs:{"customsColumns":_vm.columns,"getParams":_vm.getParams}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }